import MuiButton from "../Styled/Button";
import { merge } from "lodash";

export default function Button({ props, rest }: any) {
  const { label, icon, render = true } = rest;
  const mergedProps = merge({}, props);

  if (!render) return <></>;

  return icon ? (
    <MuiButton {...mergedProps}>{icon}</MuiButton>
  ) : (
    <MuiButton {...mergedProps}>
      {label}
      {icon}
    </MuiButton>
  );
}
